module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_first-prize.3d897287.png";